<ul class="breadcrumb breadcrumb-page">
  <li><a href="#">{{'app.Home' | translate}}</a></li>
  <li class="active">Merged {{label}}s</li>
</ul>

<div class="page-header">
  <div class="row">
    <h1 class="col-xs-12 text-center text-left-sm">Merged {{label}}s</h1>
  </div>
</div>

<!-- merges in effect -->
<div class="panel panel-success widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">Current merges ({{mergedTotal}})</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="row" style="margin-bottom:10px;">
      <div class="col-sm-4">
        <input type="text" class="form-control" name="search" [(ngModel)]="search" (keyup.enter)="loadMerged(1)"
               placeholder="ID or name (merged or surviving)" autocomplete="off" />
      </div>
      <div class="col-sm-3"><input type="date" class="form-control" name="fromDate" [(ngModel)]="fromDate" title="Merged from" /></div>
      <div class="col-sm-3"><input type="date" class="form-control" name="toDate" [(ngModel)]="toDate" title="Merged to" /></div>
      <div class="col-sm-2"><button type="button" class="btn btn-save" (click)="loadMerged(1)">{{'app.Search' | translate}}</button></div>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Merged (hidden) {{label}}</th>
            <th>Surviving {{label}}</th>
            <th>Merged on</th>
            <th>Merged by</th>
            <th *ngIf="canUnmerge"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loadingMerged"><td colspan="5" class="text-center"><i class="fa fa-spinner fa-spin"></i> {{'app.Loading' | translate}}</td></tr>
          <tr *ngIf="!loadingMerged && merged.length === 0"><td colspan="5" class="text-center">No merged {{label}}s found.</td></tr>
          <ng-container *ngIf="!loadingMerged">
            <tr *ngFor="let row of merged">
              <td><b>#{{row.absorbedId}}</b> {{row.absorbedName}}<br /><small class="text-muted">{{row.absorbedDetails}}</small></td>
              <td><b>#{{row.survivingId}}</b> {{row.survivingName}}<br /><small class="text-muted">{{row.survivingDetails}}</small></td>
              <td>{{row.mergedAt ? (row.mergedAt | date:'yyyy-MM-dd HH:mm') : '-'}}</td>
              <td>{{row.mergedBy || '-'}}</td>
              <td *ngIf="canUnmerge"><button type="button" class="btn btn-xs btn-danger" (click)="openUnmerge(row)">Unmerge</button></td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <div class="text-center" *ngIf="mergedTotal > pageSize">
      <button type="button" class="btn btn-xs" [disabled]="mergedPage <= 1" (click)="loadMerged(mergedPage - 1)">&lsaquo; Previous</button>
      &nbsp;Page {{mergedPage}} of {{pages(mergedTotal)}}&nbsp;
      <button type="button" class="btn btn-xs" [disabled]="mergedPage >= pages(mergedTotal)" (click)="loadMerged(mergedPage + 1)">Next &rsaquo;</button>
    </div>
  </div>
</div>

<!-- merges that were undone -->
<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">Undone merges ({{undoneTotal}})</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="table-responsive">
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Restored {{label}}</th>
            <th>Was merged into</th>
            <th>Undone on</th>
            <th>Undone by</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loadingUndone"><td colspan="4" class="text-center"><i class="fa fa-spinner fa-spin"></i> {{'app.Loading' | translate}}</td></tr>
          <tr *ngIf="!loadingUndone && undone.length === 0"><td colspan="4" class="text-center">No undone merges.</td></tr>
          <ng-container *ngIf="!loadingUndone">
            <tr *ngFor="let row of undone">
              <td><b>#{{row.absorbedId}}</b> {{row.absorbedName}}</td>
              <td><b>#{{row.survivingId}}</b> {{row.survivingName}}</td>
              <td>{{row.undoneAt | date:'yyyy-MM-dd HH:mm'}}</td>
              <td>{{row.undoneBy || '-'}}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <div class="text-center" *ngIf="undoneTotal > pageSize">
      <button type="button" class="btn btn-xs" [disabled]="undonePage <= 1" (click)="loadUndone(undonePage - 1)">&lsaquo; Previous</button>
      &nbsp;Page {{undonePage}} of {{pages(undoneTotal)}}&nbsp;
      <button type="button" class="btn btn-xs" [disabled]="undonePage >= pages(undoneTotal)" (click)="loadUndone(undonePage + 1)">Next &rsaquo;</button>
    </div>
  </div>
</div>

<!-- unmerge: preview + typed confirmation -->
<div class="modal fade" bsModal #unmergeModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <h1 class="filter-title">Unmerge {{label}} #{{selected?.absorbedId}}</h1>
      <div class="panel-body padding-sm-hr">
        <div *ngIf="loadingPlan" class="text-center"><i class="fa fa-spinner fa-spin"></i> Checking what can be restored...</div>
        <ng-container *ngIf="plan">
          <div *ngIf="!plan.canUnmerge" class="alert alert-danger">{{plan.problem}}</div>
          <ng-container *ngIf="plan.canUnmerge">
            <p>
              <b>#{{plan.absorbedId}} {{plan.absorbedName}}</b> will be restored and separated from
              <b>#{{plan.survivingId}} {{plan.survivingName}}</b> again.
              It was merged on {{plan.mergedAt | date:'yyyy-MM-dd HH:mm'}}{{plan.mergedBy ? ' by ' + plan.mergedBy : ''}}.
            </p>
            <table class="table table-bordered table-condensed">
              <thead><tr><th>Moved back to #{{plan.absorbedId}}</th><th>Records</th><th>Changed since the merge (left as they are)</th></tr></thead>
              <tbody>
                <tr *ngFor="let item of plan.items">
                  <td>{{entityName(item.entity)}}</td>
                  <td>{{item.toRestore}}</td>
                  <td [class.text-danger]="item.changedSince > 0">{{item.changedSince}}</td>
                </tr>
              </tbody>
            </table>
            <p *ngIf="plan.visitsAfterMerge > 0" class="text-warning">
              {{plan.visitsAfterMerge}} visit(s) recorded on #{{plan.survivingId}} after the merge stay with #{{plan.survivingId}}.
            </p>
            <label class="control-label">Type <b>{{plan.absorbedId}}</b> to confirm</label>
            <input type="text" class="form-control" name="confirmText" [(ngModel)]="confirmText" autocomplete="off" />
          </ng-container>
        </ng-container>
      </div>
      <div class="panel-footer margin-left-20 margin-top-20">
        <button type="button" class="btn btn-cancel" (click)="unmergeModal.hide()" [disabled]="unmerging">{{'app.cancel' | translate}}</button>
        <button type="button" class="btn btn-danger" (click)="unmerge()" [disabled]="!confirmed || unmerging">{{unmerging ? 'Unmerging...' : 'Unmerge'}}</button>
      </div>
    </div>
  </div>
</div>
